import SideBarContainer from 'Containers/SideBarContainer';
import ReportsLayout from 'Pages/reports/components/ReportsLayout/ReportsLayout';
import ServerPaginatedTable from './components/ServerPaginatedTable/ServerPaginatedTable';
import HistoryReportFilters from './components/HistoryReportFilters/HistoryReportFilters';
import useHistoryReportPage from './hooks/useHistoryReportPage';
import { Padding } from 'Components/Padding';
import ReportsTitle from 'Pages/reports/components/ReportsTitle/ReportsTitle';
import { buildTime } from 'Pages/reports/utils/buildTime';
import { FaPeopleGroup } from 'react-icons/fa6';
import { MdSchool } from 'react-icons/md';

export default function Page() {
  const {
    historyReportData,
    historyReportMeta,
    historyReportLoading,
    historyReportError,
    t2,
    handleSearch,
    handlePageChange,
    handleRowsPerPageChange,
    handleExport,
    handleRowClick,
  } = useHistoryReportPage();

  const buttons = [
    {
      icon: <FaPeopleGroup size={24} />,
      tooltip: t2('employees_report_tooltip'),
      route: '/reporte/historial/empleados',
    },
    { icon: <MdSchool size={24} />, tooltip: t2('courses_report_tooltip'), route: '/reporte/historial/cursos' },
  ];

  return (
    <SideBarContainer>
      <ReportsLayout
        title={<ReportsTitle title={t2('title')} accent={t2('title_accent')} />}
        buttons={buttons}
        onExport={handleExport}
      />
      <Padding padding="1rem">
        <HistoryReportFilters onSearch={handleSearch} />
        <Padding padding="0.5rem 0" />
        <ServerPaginatedTable
          columns={[
            { id: 'payroll', label: t2('payroll_number'), align: 'center' },
            { id: 'fullName', label: t2('full_name') },
            { id: 'terminal', label: t2('terminal') },
            { id: 'department', label: t2('department') },
            { id: 'jobTitle', label: t2('job_title') },
            { id: 'gender', label: t2('gender') },
            { id: 'age', label: t2('age'), align: 'center' },
            { id: 'entryDate', label: t2('entry_date') },
            { id: 'totalCoursesAssigned', label: t2('total_courses'), align: 'center' },
            { id: 'pendingCourses', label: t2('pending_courses'), align: 'center' },
            { id: 'completedCourses', label: t2('completed_courses'), align: 'center' },
            { id: 'trainingHours', label: t2('training_hours'), align: 'center' },
          ]}
          rows={historyReportData.map(item => ({
            id: item.id,
            payroll: item.payroll,
            fullName: item.fullName,
            terminal: item.terminal || '-',
            department: item.department || '-',
            jobTitle: item.jobTitle || '-',
            gender: item.gender || '-',
            age: item.age ?? '-',
            entryDate: item.entryDate || '-',
            totalCoursesAssigned: item.totalCoursesAssigned === 0 ? '-' : item.totalCoursesAssigned,
            pendingCourses: item.pendingCourses === 0 ? '-' : item.pendingCourses,
            completedCourses: item.completedCourses === 0 ? '-' : item.completedCourses,
            trainingHours: buildTime(item.trainingHours, t2),
          }))}
          meta={historyReportMeta}
          loading={historyReportLoading}
          error={historyReportError}
          onPageChange={handlePageChange}
          onRowsPerPageChange={handleRowsPerPageChange}
          onRowClick={handleRowClick}
        />
      </Padding>
    </SideBarContainer>
  );
}
